
import { defineComponent } from 'vue'
import { Registration } from '@/services/Registration'
import { atbInfoService } from '@/services/AtbInfoService'
import { eventBus } from '@/services/EventBus'

export default defineComponent({
  data () {
    return {
      company: '',
      name: '',
      phone: '',
      email: '',
      copy: 'false',
      pickup: '',
      crn: '',
      url: '',
      error: {
        transfer: false
      }
    }
  },
  props: {
    trackingNumber: {
      type: Number,
      required: true
    },
    cfs: {
      type: String,
      required: true
    }
  },
  methods: {
    validateField (e: Event) {
      e.preventDefault()
      const element = e.target as HTMLInputElement
      const msg = element.validationMessage.replace(/\([^)]+\)./, '')
      this.toggleValidation(element, element.validity.valid, msg)
    },
    submit (e: Event) {
      const pickupDate = new Date(this.pickup)
      const tomorrow = new Date()
      tomorrow.setHours(0)
      tomorrow.setMinutes(0)
      tomorrow.setSeconds(0)
      tomorrow.setMilliseconds(0)
      tomorrow.setHours(tomorrow.getHours() + 24)

      if (pickupDate < tomorrow) {
        const pickupField = (this.$refs.form as HTMLFormElement).querySelector('input[name="pickup"]') as HTMLInputElement
        if (pickupField) {
          this.toggleValidation(pickupField,
            false,
            'Das Abholdatum muss in der Zukunft liegen')
        }
        return
      }

      const registration = {
        trackingNumber: this.trackingNumber,
        company: this.company,
        name: this.name,
        phone: this.phone,
        email: this.email,
        copy: this.copy === 'true',
        pickUpDate: pickupDate.toISOString(),
        crn: this.crn,
        url: this.url
      } as Registration
      const form = e.target as HTMLElement
      form.querySelectorAll('input').forEach(e => { e.disabled = true })
      atbInfoService.registerForPickup(
        registration,
        document.querySelector('meta[name="_csrf_header"]')?.getAttribute('content') || '',
        document.querySelector('meta[name="_csrf"]')?.getAttribute('content') || ''
      ).then(() => {
        eventBus.emit(
          {
            name: 'toast',
            payload: {
              message: 'Angemeldet zur Abnahme'
            }
          }
        )
        this.$router.push({ path: '/' })
      }).catch(e => {
        form.querySelectorAll('input').forEach(e => { e.disabled = false })
        if (e.message === 'invalid-email') {
          const emailField = this.$el.form.querySelector('input[name="email"]') as HTMLInputElement
          if (emailField) {
            this.toggleValidation(emailField, true, 'Die eingegebene Email ist ungültig')
          }
        } else if (e.message === 'generic-error') {
          this.error.transfer = true
        }
      })
    },
    toggleValidation (element: Element, valid: boolean, message: string) {
      const field = element
      const fieldHelp = element.parentElement?.querySelector('p.help')
      if (valid) {
        field.classList.remove('is-danger')
        if (fieldHelp && !fieldHelp.classList.contains('is-hidden')) {
          fieldHelp.textContent = ''
          fieldHelp.classList.add('is-hidden')
        }
      } else {
        if (!field.classList.contains('is-danger')) {
          field.classList.add('is-danger')
        }

        if (fieldHelp) {
          fieldHelp.textContent = message
          if (fieldHelp.classList.contains('is-hidden')) {
            fieldHelp.classList.remove('is-hidden')
          }
        }
      }
    }
  }
})
